<template>
    <div class="login">
    
        <!-- 用户信息界面 -->
    
        <div class="adminInfo" v-if="loginHidden">
    
            <div class="loginTitle">
    
                <p>用户信息</p>
    
            </div>
    
            <el-divider></el-divider>
    
            <el-card class="card">
    
                <el-row>
    
                    <el-col :span="6">姓名：</el-col>
    
                    <el-col :span="18">{{ userInfo.user_name }}</el-col>
    
                </el-row>
    
                <el-row>
    
                    <el-col :span="6">手机号：</el-col>
    
                    <el-col :span="18">{{ userInfo.tel }}</el-col>
    
                </el-row>
    
                <el-row>
    
                    <el-col :span="6">邮箱：</el-col>
    
                    <el-col :span="18">{{ userInfo.email }}</el-col>
    
                </el-row>
    
                <div class="resetHerf">
    
                    <a href="javascript:void(0)" @click="resetPassHandle">修改密码</a>
    
    
    
                    <a href="javascript:void(0)" @click="updataHandle">修改个人信息</a>
    
    
    
                    <router-link to="/History">查看历史记录</router-link>
    
                    <!-- <a href="#">查看历史记录</a> -->
    
                </div>
    
                <!-- <el-form-item class="btn">
    
              <el-button type="primary" @click="loginBtn('loginInfo')">登录</el-button>
    
              <el-button type="success" class="rsetBtn" @click="registerBtn">注册</el-button>
    
            </el-form-item> -->
    
                <el-row type="flex" justify="space-between" class="apply">
    
                    <el-col :span="10" class="btnLeft">
    
                        <el-button type="success" @click="applyBtn">报名入口</el-button>
    
                    </el-col>
    
                    <el-col :span="10" class="btnRight">
    
                        <el-button type="danger" @click="loginOutBtn">注销登录</el-button>
    
                    </el-col>
    
                </el-row>
    
            </el-card>
    
        </div>
    
        <!-- 登录界面 -->
    
        <div v-else v-loading="loading" element-loading-text="登陆中">
    
            <div class="loginTitle">
    
                <p>用户登录</p>
    
            </div>
    
            <el-divider></el-divider>
    
            <div class="loginForm">
    
                <el-card class="card">
    
                    <el-form label-width="80px" label-position="top" :model="loginInfo" :rules="loginRules" @keyup.native="keyUploginPass" ref="loginInfo">
    
                        <el-form-item label="手机号" prop="phone">
    
                            <el-input v-model="loginInfo.phone" placeholder="请输入已注册的手机号" :maxlength="11"></el-input>
    
                        </el-form-item>
    
                        <el-form-item label="密码" prop="pass">
    
                            <el-input v-model="loginInfo.pass" placeholder="请输入密码" :maxlength="16" show-password></el-input>
    
                        </el-form-item>
    
                        <el-form-item label="验证码" prop="captcha_code">
    
                            <span class="codeInfo">(验证码可点击刷新，无需区分大小写)</span>
    
                            <el-input v-model="loginInfo.captcha_code" placeholder="请输入验证码" :maxlength="5" class="captchaSty"></el-input>
    
                            <div class="captcha_code">
    
                                <img :src="codeImage" ref="code" @click="changeCode" />
    
                            </div>
    
                        </el-form-item>
    
                        <el-row type="flex" justify="center">
    
                            <span class="prompt">(登录后才可进行报名)</span>
    
                        </el-row>
    
                        <el-form-item class="btn">
    
                            <el-button type="primary" @click="loginBtn('loginInfo')">登录</el-button>
    
                            <el-button type="success" class="rsetBtn" @click="registerBtn">注册</el-button>
    
                        </el-form-item>
    
                        <!-- 忘记密码 -->
    
                        <div class="resetPas">
    
                            <a href="javascript:void(0)" @click="forgetHandle">忘记密码</a>
    
                        </div>
    
                    </el-form>
    
                </el-card>
    
            </div>
    
        </div>
    
        <!-- 忘记密码弹框 -->
    
        <el-dialog title="重置密码" :visible.sync="forgetVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    
            <el-form :model="forgetPass" :rules="forgetPassRules" ref="forgetPass">
    
                <el-form-item label="手机号" type="tel" prop="forgetpassPhone">
    
                    <el-input v-model="forgetPass.forgetpassPhone" autocomplete="off" :maxlength="11" @keyup.native="handleClick($event)"></el-input>
    
                </el-form-item>
    
                <el-form-item label="身份证号" prop="forgetpassidCard">
    
                    <el-input v-model="forgetPass.forgetpassidCard" autocomplete="off" :maxlength="18"></el-input>
    
                </el-form-item>
    
                <el-form-item label="新的密码" prop="newPasswords">
    
                    <el-input v-model="forgetPass.newPasswords" show-password :maxlength="16" autocomplete="off"></el-input>
    
                </el-form-item>
    
                <el-form-item label="确认密码" prop="surePass">
    
                    <el-input v-model="forgetPass.surePass" show-password :maxlength="16" autocomplete="off"></el-input>
    
                </el-form-item>
    
                <!-- 验证码 -->
    
                <el-row>
    
                    <el-form-item label="手机验证码" prop="smsCode"> </el-form-item>
    
                </el-row>
    
                <el-row>
    
                    <el-row>
    
                        <el-col :span="12">
    
                            <el-input v-model="forgetPass.smsCode" placeholder="请输入手机验证码" :maxlength="6"></el-input>
    
                        </el-col>
    
                        <el-col :span="8" :offset="2">
    
                            <el-button type="primary" @click="smsSendHandle('forget')" ref="forgetBtnRefs" :disabled="disabledButton">{{ buttonInfo }}</el-button>
    
                        </el-col>
    
                    </el-row>
    
                </el-row>
    
            </el-form>
    
            <div slot="footer" class="dialog-footer">
    
                <el-button type="primary" @click="forgetSureBtn">确 定</el-button>
    
                <el-button @click="forgetCancelBtn">取 消</el-button>
    
            </div>
    
        </el-dialog>
    
        <!-- 修改密码弹框 -->
    
        <el-dialog title="修改密码" :visible.sync="resetPassVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    
            <el-form :model="resetPass" :rules="resetPassRules" ref="resetPass">
    
                <el-form-item label="原始密码" prop="oldPassWords">
    
                    <el-input v-model="resetPass.oldPassWords" autocomplete="off" show-password placeholder="请输入原始密码" :maxlength="16"></el-input>
    
                </el-form-item>
    
                <el-form-item label="新的密码" prop="newPasswords">
    
                    <el-input v-model="resetPass.newPasswords" show-password autocomplete="off" placeholder="请输入新的密码" :maxlength="16"></el-input>
    
                </el-form-item>
    
                <el-form-item label="确认密码" prop="surePass">
    
                    <el-input v-model="resetPass.surePass" show-password autocomplete="off" placeholder="请在此输入新的密码" :maxlength="16"></el-input>
    
                </el-form-item>
    
                <el-row>
    
                    <el-form-item label="验证码" prop="code"></el-form-item>
    
                </el-row>
    
                <el-row>
    
                    <el-col :span="8">
    
                        <el-input v-model="resetPass.code" placeholder="请输入验证码" :maxlength="5" class="captchaSty"></el-input>
    
                    </el-col>
    
    
    
                    <el-col :span="4" :offset="1">
    
                        <div class="captcha_code">
    
                            <img :src="resetCodeImg" ref="resetRef" @click="resetChangeCode" /></div>
    
                    </el-col>
    
                </el-row>
    
            </el-form>
    
            <div slot="footer" class="dialog-footer">
    
                <el-button type="primary" @click="resetSureBtn">确 定</el-button>
    
                <el-button @click="resetCancelBtn">取 消</el-button>
    
            </div>
    
        </el-dialog>
    
        <!-- 修改个人信息 -->
    
        <el-dialog title="修改个人信息" :visible.sync="updataVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    
            <el-form :model="updataPersonal" :rules="updataPerRules" ref="updataPerRef">
    
                <el-form-item label="姓名" prop="user_name">
    
                    <el-input v-model="updataPersonal.user_name" autocomplete="off"></el-input>
    
                </el-form-item>
    
                <el-form-item label="手机号" prop="tel">
    
                    <span v-if="phoneInput" style="color:#c0c4cc">（您当前有正在参与的报名，结束后才可修改手机号）</span>
    
                    <el-input v-model="updataPersonal.tel" autocomplete="off" :maxlength="11" @keyup.native="keyUpRsetPersonal" :disabled="phoneInput"></el-input>
    
                </el-form-item>
    
                <el-form-item label="身份证号" prop="id_card">
    
                    <el-input v-model="updataPersonal.id_card" autocomplete="off" :maxlength="18"></el-input>
    
                </el-form-item>
    
                <el-form-item label="邮箱" prop="email">
    
                    <el-input v-model="updataPersonal.email" autocomplete="off"></el-input>
    
                </el-form-item>
    
                <el-row>
    
                    <el-form-item label="手机验证码" prop="code"></el-form-item>
    
                </el-row>
    
                <el-row>
    
                    <el-col :span="8">
    
                        <el-input v-model="updataPersonal.code" placeholder="请输入手机验证码" maxlength="6" class="captchaSty"></el-input>
    
                    </el-col>
    
    
    
                    <el-col :span="8" :offset="1">
    
                        <el-button type="primary" @click="smsSendHandle('person')" :disabled="disabledButton">{{ buttonInfo }}</el-button>
    
                    </el-col>
    
                </el-row>
    
            </el-form>
    
            <div slot="footer" class="dialog-footer">
    
                <el-button type="primary" @click="updataSureBtn">确 定</el-button>
    
                <el-button @click="updataCancelBtn">取 消</el-button>
    
            </div>
    
        </el-dialog>
    
        <!-- 发送验证码校验 -->
    
        <el-dialog :visible.sync="imgCodeVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="请先输入图形验证码再发送">
    
            <el-form :model="sendImgCode">
    
                <el-form-item prop="codeInput" :rules="[
    
                {
    
                  required: true,
    
                  message: '请输入验证码',
    
                  trigger: ['change', 'blur']
    
                }
    
              ]"></el-form-item>
    
                <el-row>
    
                    <el-col :span="8">
    
                        <el-input v-model="sendImgCode.codeInput" placeholder="请输入验证码" :maxlength="5" class="captchaSty"></el-input>
    
                    </el-col>
    
                    <el-col :span="4" :offset="1">
    
                        <div class="captcha_code">
    
                            <img :src="sendImgCode.sendImageUrl" @click="sendImgChange" /></div>
    
                    </el-col>
    
                </el-row>
    
            </el-form>
    
            <div slot="footer" class="dialog-footer">
    
                <el-button type="primary" @click="imgSureBtn">确 定</el-button>
    
                <el-button @click="imgCancleBtn">取 消</el-button>
    
            </div>
    
        </el-dialog>
    
    </div>
</template>
<script>
// import { mapState, mapActions } from 'vuex'
export default {
    data() {
        // 自定义验证规则，手机号验证
        var validatePhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入手机号'))
            } else {
                const reg = /^1[3-9][0-9]\d{8}$/
                if (reg.test(value)) {
                    callback()
                } else {
                    return callback(new Error('请输入正确的手机号'))
                }
            }
        }
        // 确认密码(忘记密码)
        var validatePassForget = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.forgetPass.newPasswords) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        // 确认密码(修改密码)
        var validatePassReset = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.resetPass.newPasswords) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            setSendSms: '',
            buttonInfo: '发送验证码',
            loginHidden: false,
            resetPassVisible: false,
            forgetVisible: false,
            updataVisible: false,
            imgCodeVisible: false,
            loading: false,
            forgetBtn: false,
            personBtn: false,
            disabledButton: false,
            phoneInput: false,
            time: 0,
            codeImage: '',
            forgetCodeImage: '',
            resetCodeImg: '',
            updataCodeImg: '',
            sendImgCode: {
                codeInput: '',
                sendImageUrl: ''
            },
            sendSms: false,
            // 登录信息
            loginInfo: {
                phone: '',
                pass: '',
                captcha_code: ''
            },
            // 用户信息
            userInfo: {
                email: '',
                tel: '',
                user_name: '',
                id_card: ''
            },
            // 忘记密码
            forgetPass: {
                forgetpassPhone: '',
                forgetpassidCard: '',
                newPasswords: '',
                surePass: '',
                forgetpass_code: '',
                smsCode: ''
            },
            // 重置密码
            resetPass: {
                Phone: '',
                oldPassWords: '',
                newPasswords: '',
                surePass: '',
                code: ''
            },
            // 更新个人信息
            updataPersonal: {
                user_name: '',
                tel: '',
                id_card: '',
                email: '',
                code: ''
            },
            // 登录验证
            loginRules: {
                phone: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: ['change', 'blur']
                    },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                pass: [{
                        required: true,
                        message: '请输入密码',
                        trigger: ['change', 'blur']
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,16}$/,
                        message: '密码由6-16位字母或数字组成',
                        trigger: 'blur'
                    }
                ],
                captcha_code: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: ['change', 'blur']
                }]
            },
            // 忘记密码验证
            forgetPassRules: {
                forgetpassPhone: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: ['change', 'blur']
                    },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                forgetpassidCard: [{
                        required: true,
                        message: '请输入身份证号',
                        trigger: ['change', 'blur']
                    },
                    {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '请输入正确的身份证号',
                        trigger: 'blur'
                    }
                ],
                newPasswords: [{
                        required: true,
                        message: '请输入密码',
                        trigger: ['change', 'blur']
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,16}$/,
                        message: '密码由6-16位字母或数字组成',
                        trigger: 'blur'
                    }
                ],
                surePass: [{
                        required: true,
                        message: '请输入密码',
                        trigger: ['change', 'blur']
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,16}$/,
                        message: '密码由6-16位字母或数字组成',
                        trigger: 'blur'
                    },
                    { validator: validatePassForget, trigger: 'blur' }
                ],
                forgetpass_code: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: ['change', 'blur']
                }],
                smsCode: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: ['change', 'blur']
                }]
            },
            // 修改密码验证
            resetPassRules: {
                Phone: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: ['change', 'blur']
                    },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                oldPassWords: [{
                        required: true,
                        message: '请输入原始密码',
                        trigger: ['change', 'blur']
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,16}$/,
                        message: '密码由6-16位字母或数字组成',
                        trigger: 'blur'
                    }
                ],
                newPasswords: [{
                        required: true,
                        message: '请输入密码',
                        trigger: ['change', 'blur']
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,16}$/,
                        message: '密码由6-16位字母或数字组成',
                        trigger: 'blur'
                    }
                ],
                surePass: [{
                        required: true,
                        message: '请输入确认密码',
                        trigger: ['change', 'blur']
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,16}$/,
                        message: '密码由6-16位字母或数字组成',
                        trigger: 'blur'
                    },
                    { validator: validatePassReset, trigger: ['blur'] }
                ],
                code: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: ['change', 'blur']
                }]
            },
            // 修改个人信息验证
            updataPerRules: {
                user_name: [{
                    required: true,
                    message: '请输入姓名',
                    trigger: ['change', 'blur']
                }],
                tel: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: ['change', 'blur']
                    },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                id_card: [{
                        required: true,
                        message: '请输入身份证号',
                        trigger: ['change', 'blur']
                    },
                    {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '请输入正确的身份证号',
                        trigger: 'blur'
                    }
                ],
                email: [{
                        required: true,
                        message: '请输入邮箱',
                        trigger: ['change', 'blur']
                    },
                    {
                        type: 'email',
                        message: '请输入正确的邮箱地址',
                        trigger: ['blur']
                    }
                ],
                code: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: ['change', 'blur']
                }]
            },
            baseUrl: 'https://baoming.i60.cc'
        }
    },

    created() {
        const tokenStr = window.sessionStorage.getItem('token')
        if (tokenStr) {
            this.getMySignupList()
            this.getUserInfo()
            this.loginHidden = true
        } else {
            this.loginHidden = false
        }
        this.getCode()
    },
    methods: {
        handleClick(e) {
            // this.famount = this.famount.replace(/[^\.\d]/g, '')
            // this.famount = this.famount.replace('.', '')
            this.forgetPass.forgetpassPhone = this.forgetPass.forgetpassPhone.replace(/[^\.\d]/g, '')
            this.forgetPass.forgetpassPhone = this.forgetPass.forgetpassPhone.replace('.', '')
        },
        keyUploginPass() {
            this.loginInfo.phone = this.loginInfo.phone.replace(/[^\.\d]/g, '')
            this.loginInfo.phone = this.loginInfo.phone.replace('.', '')
        },
        keyUpRsetPersonal() {
            this.updataPersonal.tel = this.updataPersonal.tel.replace(/[^\.\d]/g, '')
            this.updataPersonal.tel = this.updataPersonal.tel.replace('.', '')
        },
        // 倒计时
        timer() {
            if (this.time > 0) {
                this.time--
                    this.buttonInfo = this.time + 's后重新获取'
                setTimeout(this.timer, 1000)
            } else {
                this.time = 0
                this.buttonInfo = '发送验证码'
                this.disabledButton = false
            }
        },
        // 忘记密码提交api
        async resetPassApi() {
            const params = this.formData({
                password: this.forgetPass.newPasswords,
                password2: this.forgetPass.surePass,
                tel: this.forgetPass.forgetpassPhone,
                idcard: this.forgetPass.forgetpassidCard,
                smsCode: this.forgetPass.smsCode
            })
            const { data: res } = await this.$axios.post('/api/user/ResetPassword', params)
            console.log(res)
            if (res.response_code == 200) {
                this.$message({
                    type: 'success',
                    message: '密码重置成功',
                    offset: '300'
                })
                this.$refs.forgetPass.resetFields()
                this.forgetVisible = false
            } else {
                this.$message({
                    type: 'error',
                    message: res.response_msg,
                    offset: '300'
                })
                // this.disabledButton = false
                // this.$refs.forgetPass.resetFields()
            }
        },
        // 修改用户密码api
        async updataPassApi() {
            const params = this.formData({
                passwordOld: this.resetPass.oldPassWords,
                password: this.resetPass.newPasswords,
                password2: this.resetPass.surePass,
                smsCode: this.resetPass.code
            })
            console.log(params)
            const { data: res } = await this.$axios.post('/api/user/changePassword', params)
            console.log(res)
            this.loading = false
            if (res.response_code == 200) {
                this.$alert('密码修改成功，请重新登录', '修改成功', {
                    confirmButtonText: '确定',
                    type: 'success'
                }).then(() => {
                    this.$refs.resetPass.resetFields()
                    this.loginOutBtn()
                    this.resetPassVisible = false
                })
            } else {
                this.$message({
                    type: 'error',
                    message: res.response_msg,
                    offset: '300'
                })
            }
        },
        // 获取当前报名信息Api（用于判断是否可以更新手机号）
        async getMySignupList() {
            const { data: res } = await this.$axios.get('/api/signup/mySignupList')
            console.log(res)
            this.loading = false
            if (res.response_code == 200) {
                this.info = res.data
                this.info.forEach((item, index) => {
                    if (item.signup_status_code !== 201) {
                        this.phoneInput = true
                    }
                })
            }
        },
        // 更新个人信息Api
        async updataPersonApi(params) {
            const paramsData = this.formData(params)
            const { data: res } = await this.$axios.post('/api/user/Update', paramsData)
            console.log(res)
            if (res.response_code == 200) {
                this.$alert('个人信息修改成功', '修改成功', {
                    confirmButtonText: '确定',
                    type: 'success'
                }).then(() => {
                    // this.disabledButton = false
                    this.updataVisible = false
                    this.$router.go(0)
                    this.$refs.updataPerRef.resetFields()
                })
                // this.userInfo = this.updataPersonal
                // console.log(this.updataPersonal)
            } else {
                this.$message({
                    type: 'error',
                    message: res.response_msg,
                    offset: '300'
                })
            }
        },
        // 发送忘记密码验证码接口
        forgetcodeHandle() {
            console.log(this.$refs.forgetPass)
            this.$refs.forgetPass.validateField('forgetpassPhone', valid => {
                console.log(valid)
                if (valid) {
                    this.$message({
                        type: 'warning',
                        message: '请先填写正确的手机号',
                        offset: 300
                    })
                } else {
                    console.log('ok')
                    // 发请求
                    const params = {
                        tel: this.forgetPass.forgetpassPhone
                    }
                    this.$axios
                        .get('api/sms/SendSmsCode', {
                            params: params
                        })
                        .then(result => {
                            // 已发
                            console.log(result)
                            this.$message({
                                type: 'success',
                                message: '验证码已发送您的手机，60s后可再次发送，请注意查收',
                                offset: 300
                            })
                            // console.log(this.$refs.forgetBtnRefs._props.disabled)
                            this.disabledButton = true
                            // 验证码倒计时
                            this.time = 60
                            this.timer()
                            // setTimeout(() => {
                            //   this.forgetBtn = false
                            // }, 60000)
                            console.log('发送验证码')
                        })
                }
            })
        },
        personcodeHandle() {
            this.$refs.updataPerRef.validateField('tel', valid => {
                console.log(valid)
                if (valid) {
                    this.$message({
                        type: 'warning',
                        message: '请先填写正确的手机号',
                        offset: 300
                    })
                } else {
                    console.log('ok')
                    // 发请求
                    let loadSmsCoad = this.$loading({ text: '正在发送手机验证码' })
                    const params = {
                        tel: this.updataPersonal.tel
                    }
                    this.$axios
                        .get('api/sms/SendSmsCode', {
                            params: params
                        })
                        .then(result => {
                            // 已发
                            loadSmsCoad.close()
                            console.log(result)
                            this.$message({
                                type: 'success',
                                message: '验证码已发送您的手机，60s后可再次发送，请注意查收',
                                offset: 300
                            })
                            // console.log(this.$refs.forgetBtnRefs._props.disabled)
                            this.disabledButton = true
                            this.time = 60
                            this.timer()
                            console.log('发送验证码')
                        })
                }
            })
        },

        // 获取校验验证码
        async getSendImgUrl() {
            // var num = Math.ceil(Math.random() * 10)
            // this.sendImgCode.sendImageUrl = '/api/captcha/CreateCode?vcodeName=sendImg&a=' + num
            const { data: res } = await this.$axios.get('/api/captcha/CreateCode')
            this.sendImgCode.sendImageUrl = res.base64
            this.sendImgCode.key = res.key
        },
        // 获取登录验证码
        async getCode() {
            // var num = Math.ceil(Math.random() * 10)
            // this.codeImage = '/api/captcha/CreateCode?vcodeName=codeImage&a=' + num
            const { data: res } = await this.$axios.get('/api/captcha/CreateCode')
            this.codeImage = res.base64
            this.vcodeKey = res.key
        },
        // 获取忘记密码验证码
        forgetGetCode() {
            console.log("aaa")
            var num = Math.ceil(Math.random() * 10)
            this.forgetCodeImage = '/api/captcha/CreateCode?vcodeName=forgetCodeImg&a=' + num
        },
        // 获取修改密码验证码
        async resetGetCode() {
            // var num = Math.ceil(Math.random() * 10)
            // this.resetCodeImg = '/api/captcha/CreateCode?vcodeName=resetCodeImg&a=' + num
            const { data: res } = await this.$axios.get('/api/captcha/CreateCode')
            this.resetCodeImg = res.base64
            this.vcodeKey = res.key
        },
        // 获取修改个人信息验证码
        updataGetCod() {
            var num = Math.ceil(Math.random() * 10)
            this.updataCodeImg = '/api/captcha/CreateCode?vcodeName=updatacodeImage&a=' + num
        },
        //  获取用户信息
        async getUserInfo() {
            const { data: res } = await this.$axios.post('/api/user/getUserInfo')
            console.log(res)
            if (res.response_code == 200) {
                this.userInfo = res.data
            }
        },
        // 点击忘记密码弹框
        forgetHandle() {
            this.forgetGetCode()
            this.forgetVisible = true
        },
        // 点击登录
        loginBtn(val) {
            this.$refs.loginInfo.validate(async valid => {
                if (!valid) return
                // 发送请求....
                this.loading = true
                // 校验验证码
                const codeParams = this.formData({
                    vcode: this.loginInfo.captcha_code
                })
                // const { data: res } = await this.$axios.post('/api/captcha/VerifyCode?vcodeName=codeImage', codeParams, { withCredentials: true })
                // console.log(res)
                // if (res.response_code == 200) {
                const params = this.formData({
                    tel: this.loginInfo.phone,
                    password: this.loginInfo.pass,
                    vcode: this.loginInfo.captcha_code,
                    vcode_key: this.vcodeKey
                })
                // console.log(params)
                this.$axios
                    .post('/api/user/login', params)
                    .then(result => {
                        const { data: res } = result
                       
                        if (res.response_code == 200) {
                            this.$message({
                                type: 'success',
                                message: '登录成功',
                                offset: '300'
                            })
                            res.data.token = 'Bearer '+res.data.token
                            window.sessionStorage.setItem('token', res.data.token)
                            this.loginHidden = true
                            // this.getUserInfo()
                            // this.userInfo = res.data
                            this.getUserInfo()
                            this.$refs.loginInfo.resetFields()
                            this.loading = false
                        }
                        if (res.response_code == 500) {
                            this.$message({
                                type: 'error',
                                message: res.response_msg,
                                offset: '300'
                            })
                            this.changeCode()
                            this.loginInfo.captcha_code = ''
                            this.loginInfo.pass = ''
                            this.loading = false
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        this.loading = false
                        this.$message({
                            message: '服务器连接是败请重试',
                            type: 'error',
                            offset: '300'
                        })
                    })
                // } else {
                //   this.$message({
                //     type: 'error',
                //     message: '验证码不正确',
                //     offset: '300'
                //   })
                //   this.getCode()
                //   this.loginInfo.captcha_code = ''
                //   this.$refs.loginInfo.clearValidate()

                //   this.loading = false
                // }
            })
        },

        // 点击修改密码
        resetPassHandle() {
            this.resetPassVisible = true
            this.resetGetCode()
        },
        // 点击修改个人信息
        updataHandle() {
            this.updataVisible = true
            this.updataPersonal = this.userInfo
            this.updataGetCod()
        },
        // 确定找回密码
        forgetSureBtn() {
            this.$refs.forgetPass.validate(valid => {
                console.log(valid)
                if (valid) {
                    // 发送请求....
                    this.resetPassApi()
                } else {
                    this.$message({
                        type: 'error',
                        message: '请正确填写表单',
                        offset: '300'
                    })
                }
            })
        },
        // 确定修改密码
        resetSureBtn() {
            this.$refs.resetPass.validate(async valid => {
                console.log(valid)
                console.log("aaa")
                if (valid) {
                    // 发送请求....
                    // let loadSetPass = this.$loading({ text: '加载中...' })
                    this.loading = false
                    // 验证码校验
                    const codeParams = this.formData({
                        vcode: this.resetPass.code
                    })
                    // const { data: res } = await this.$axios.post('/api/captcha/VerifyCode?vcodeName=resetCodeImg', codeParams, { withCredentials: true })
                    // console.log(res)

                    this.$confirm('密码修改成功将重新登录，是否确定修改密码？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                        .then(() => {
                            this.loading = true
                            this.updataPassApi()
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消提交'
                            })
                            this.resetPass.code = ''
                            this.resetGetCode()
                        })
                } else {
                    // loadSetPass.close()
                    this.resetGetCode()
                    this.$message({
                        type: 'error',
                        message: res.response_msg,
                        offset: 300
                    })
                }

            })
        },
        // 确定更新个人信息
        updataSureBtn() {
            this.$refs.updataPerRef.validate(valid => {
                console.log(valid)
                if (valid) {
                    // 发送请求....
                    const params = {
                        userName: this.updataPersonal.user_name,
                        userEmail: this.updataPersonal.email,
                        userTel: this.updataPersonal.tel,
                        userIdCard: this.updataPersonal.id_card,
                        smsCode: this.updataPersonal.code
                    }
                    console.log(params)
                    this.updataPersonApi(params)
                } else {
                    this.$message({
                        type: 'error',
                        message: '请正确填写表单',
                        offset: '300'
                    })
                }
            })
        },
        // 确定图形验证码校验
        async imgSureBtn() {
            let loadCoad = this.$loading({ text: '正在校验验证码' })
            const params = this.formData({
              sms_code: this.sendImgCode.codeInput,
              sms_key: this.sendImgCode.key
            })
            console.log(this.formData)
            const { data: res } = await this.$axios.post('/api/captcha/VerifyCode?vcodeName=sendImg', params, { withCredentials: true })
            const str = this.setSendSms
            loadCoad.close()
            console.log(res)
            if (res.response_code == 200) {
                this.sendSms = true
                this.smsSendHandle(str)
                this.imgCodeVisible = false
                this.sendImgCode.codeInput = ''
            } else {
                this.$message({
                    type: 'error',
                    message: '验证码错误,请重新输入',
                    offset: '300'
                })
                this.sendImgChange()
            }
        },
        // 取消图形验证吗校验
        imgCancleBtn() {
            this.imgCodeVisible = false
            this.sendImgCode.codeInput = ''
        },
        // 取消修改密码(重置)
        resetCancelBtn() {
            this.resetPassVisible = false
            this.$refs.resetPass.resetFields()
        },
        updataCancelBtn() {
            this.updataVisible = false
            this.$refs.updataPerRef.resetFields()
            this.sendSms = false
        },
        forgetCancelBtn() {
            this.changeCode()
            this.forgetVisible = false
            this.sendSms = false
        },
        // 刷新验证码(发送短信校验)
        sendImgChange() {
            this.getSendImgUrl()
        },
        // 刷新验证码(登录)
        changeCode() {
            console.log('刷新登录验证码！')
            this.getCode()
        },
        // 刷新验证码(忘记)
        forgetpassChangeCode() {
            console.log('刷新忘记验证码！')
            this.forgetGetCode()
        },
        // 刷新验证码(重置)
        resetChangeCode() {
            console.log('刷新重置验证码！')
            this.resetGetCode()
        },
        // 刷新验证码(修改个人信息)
        updataChangeCode() {
            console.log('刷新修改个人信息验证码！')
            this.updataGetCod()
        },
        // 发送手机验证码
        smsSendHandle(val) {
            console.log(val)
            this.setSendSms = val
            if (this.sendSms == false) {
                this.getSendImgUrl()
                this.imgCodeVisible = true
            } else {
                // 发送手机验证码
                if (val == 'forget') {
                    // alert('发送手机验证码')
                    this.forgetcodeHandle()
                } else {
                    this.personcodeHandle()
                }
            }
        },
        // 注册表单跳转
        registerBtn() {
            console.log('ok')
            this.$router.push('/Register')
        },
        // 注销登录
        loginOutBtn() {
            window.sessionStorage.clear('token')
            this.loginHidden = false
            this.$router.go(0)
        },
        // 报名跳转
        applyBtn() {
            this.$router.push('/ApplyHome')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.login {
    .loginTitle {
        font-size: 24px;
    } // 分割线
    .el-divider--horizontal {
        @include divider(2px, 15px);
    }
    .el-card,
    .el-dialog {
        .captcha_code {
            img {
                width: 110px;
                height: 40px;
            }
        }
        .el-form-item__content {
            display: flex;
            .captchaSty {
                width: 40%;
                float: left;
                margin-right: 20px;
            }
        }
        .rsetBtn {
            position: absolute;
            right: 0;
        }
        .dialog-footer {
            .el-button {
                width: 100%;
                margin: 10px 0;
            }
        }
    } // 用户信息
    .adminInfo {
        .el-row {
            margin: 25px 0;
        }
        .apply {
            padding-bottom: 15px\9\0;
            margin-top: 25px;
            .el-button {
                width: 100%; // height: 65px;
                // font-size: 24px;
            }
            .btnLeft {
                float: left;
            }
            .btnRight {
                float: right;
            }
        }
        .resetHerf {
            a {
                padding: 10px 0;
                display: block;
            }
            display: flex;
            flex-direction: column;
        }
    } // 登录框
    .loginForm {
        .prompt {
            color: red;
            font-size: 12px;
            padding: 5px 0 20px 0;
            display: block;
            text-align: center;
        }
        .el-button {
            width: 45%;
        }
        .codeInfo {
            color: #c0c4cc; // font-size: 12px;
            position: absolute;
            display: block;
            left: 65px;
            top: -50px;
        }
    }
}
</style>
